import querystring from 'querystring';

const adaptQueryString = () => {
  return (location.search) ? location.search.substring(1, location.search.length) :  null;
};

export default function parseQuerystring() {
  return querystring.parse(adaptQueryString());
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/parseQuerystring.js
 **/